"use strict";
Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _classesModel = require('../classes/Model');

var _classesModel2 = _interopRequireDefault(_classesModel);

var _Track = require('./Track');

var _Track2 = _interopRequireDefault(_Track);

var _Album = require('./Album');

var _Album2 = _interopRequireDefault(_Album);

var _classesBrowser = require('../classes/Browser');

var _classesBrowser2 = _interopRequireDefault(_classesBrowser);

var SMALL_IMAGE_THRESHOLD = 80;
var MEDIUM_IMAGE_THRESHOLD = 300;
var LARGE_IMAGE_THRESHOLD = 900;

var Artist = (function (_Model) {
    _inherits(Artist, _Model);

    function Artist(data) {
        _classCallCheck(this, Artist);

        _get(Object.getPrototypeOf(Artist.prototype), 'constructor', this).call(this, data);
    }

    /**
    * Protect attributes from mass assigment.
    * @return {Array<string>} The names of the attributes not overwritten by mass assigment.
    */

    _createClass(Artist, [{
        key: 'getTopTracks',

        /**
        * Retrieves the top-tracks for the artist. 
        *     List based on Spotify top-tracks concept.
        * @param {string} country The country for the search (ISO 3166-1 alpha-2 country code)
        * @see https://developer.spotify.com/web-api/get-artists-top-tracks/
        * @return {Promise}
        */
        value: function getTopTracks(country) {
            var _this = this;

            var browser = new _classesBrowser2['default']({
                id: this.id,
                type: this.constructor._getType(),
                market: country,
                query_type: 'artists-top-tracks',
                factory: _Track2['default']
            });
            return browser.all().then(function (tracks) {
                _this._topTracks = tracks;
                return tracks;
            });
        }

        /**
        * Initializes a conditional query for the artist's albums.
        *     You can set the album type, limit and offset by paramteres.
        * @param {object=} params The optional parameters for album type, limit and offset.
        * @return {Browser}
        */
    }, {
        key: 'albums',
        value: function albums() {
            var params = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

            var browser = new _classesBrowser2['default']({
                album_type: params.album_type || false,
                limit: params.limit || false,
                offset: params.offset || false,
                id: this.id,
                type: this.constructor._getType(),
                query_type: 'artists-albums',
                factory: _Album2['default']
            });
            return browser;
        }
    }, {
        key: 'getImage',
        value: function getImage(size) {
            var img = { width: 0, height: 0, url: '' };
            switch (size.toUpperCase()) {
                case 'S':
                    img = this.images[this.images.length - 1];
                    if (img.width > SMALL_IMAGE_THRESHOLD) {
                        console.warn('Small image not found. Returning bigger one instead.');
                    }
                    break;

                case 'M':
                    this.images.forEach(function (image) {
                        if (image.width < MEDIUM_IMAGE_THRESHOLD && image.width > SMALL_IMAGE_THRESHOLD) {
                            img = image;
                        }
                    });

                    if (!img || img.url == "") {
                        img = this.images[0];
                        console.warn('Medium image not found. Returning other size instead.');
                    }
                    break;

                case 'L':
                    this.images.forEach(function (image) {
                        if (image.width < LARGE_IMAGE_THRESHOLD && image.width > MEDIUM_IMAGE_THRESHOLD) {
                            img = image;
                        }
                    });

                    if (!img || img.url == "") {
                        img = this.images[0];
                        console.warn('Large image not found. Returning other size instead.');
                    }
                    break;

                case 'XL':
                    img = this.images[0];
                    if (img.width < LARGE_IMAGE_THRESHOLD) {
                        console.warn('Extra-large image not found. Returning smaller one instead.');
                    }
                    break;

                default:
                    img = this.images[0];
                    break;
            }

            return img;
        }
    }, {
        key: 'getRelatedArtists',
        value: function getRelatedArtists() {
            var browser = new _classesBrowser2['default']({
                id: this.id,
                type: this.constructor._getType(),
                query_type: 'artist-artists',
                factory: Artist
            });
            return browser.all();
        }
    }, {
        key: 'topTracks',
        get: function get() {
            return this._topTracks;
        }
    }], [{
        key: '_getNotFillable',
        value: function _getNotFillable() {
            return ['albums', 'tracks'];
        }
    }, {
        key: '_getType',
        value: function _getType() {
            return 'artists';
        }
    }]);

    return Artist;
})(_classesModel2['default']);

exports['default'] = Artist;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/spotify-client/lib/entities/Artist.js
 ** module id = 151
 ** module chunks = 0
 **/